import React, { Component } from 'react'
// model
import ResourceItem from '../../models/resourceItem'
import MediaExtradata from '../../../eventTracking/model/mediaExtradata'
import ReactAudioPlayer from 'react-audio-player';
interface iProps {
    extraProps: ResourceItem[],
    clazzId: string,
    spaceId: string,
    eventTrackingReport?: (params: MediaExtradata) => void
}
interface iState {
    playStartTime: number // 本次音频开始播放的时间
}
let audioInterval = null // 观看音频定时器
export default class clazzAudio extends Component<iProps, iState> {
    state: iState = {
        playStartTime: null
    }
    // 音频开始播放
    audioPlay = () => {
        console.log('音频开始播放')
        let that = this
        let {extraProps, clazzId, spaceId} = this.props
        this.setState({playStartTime: (+new Date())})
        audioInterval = setInterval(() => {
            that.props.eventTrackingReport(
                new MediaExtradata({
                    container_id: spaceId, 
                    class_id: clazzId, resource_id: 
                    extraProps[0]?.id,
                    watch_at: this.state.playStartTime, 
                    look_time: 10
                })
            )
        }, 10000)
    }
    // 音频暂停播放
    audioPause = () => {
        console.log('音频暂停播放')
        audioInterval && clearInterval(audioInterval)
    }
    componentDidMount () {
    }
    componentWillUnmount () {
        // window['player'].dispose();
        audioInterval && clearInterval(audioInterval)
    }
    render() {
        let {extraProps} = this.props
        return (
            <div className="clazzAudio">
                {extraProps &&
                <div className="clazzAudio_play">
                    <div className="clazzAudio_play_title">{extraProps[0]?.title}</div>
                    <ReactAudioPlayer
                        src={extraProps[0]?.playUrl}
                        onPlay={this.audioPlay}
                        onPause={this.audioPause}
                        // onContextMenu={(e) => e.preventDefault()}
                        // controlslist="noplaybackrate nodownload"
                  
                        controls
                    
                    />
                </div>}
            </div>
        )
    }
}
